// extracted by mini-css-extract-plugin
module.exports = {"column":"Dashboard_column__1RfYT","row":"Dashboard_row__43ygM","box":"Dashboard_box__1i-0b"};